import React, { useEffect, useId, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { FileSpreadsheet, Upload, X } from 'lucide-react';

export default function InvoiceTariffImportDialog({ busy, error, onImport, onClose }) {
    const [file, setFile] = useState(null);
    const dialogRef = useRef(null);
    const fileInput = useRef(null);
    const firstRef = useRef(null);
    const titleId = useId();
    const descriptionId = useId();
    useEffect(() => {
        const dialog = dialogRef.current;
        const opener = document.activeElement;
        dialog.showModal();
        firstRef.current.focus();
        return () => { dialog.close(); if (opener?.isConnected) opener.focus(); };
    }, []);

    return createPortal(<dialog ref={dialogRef} className="esave-workspace esave-confirmation esave-tariff-import-dialog" aria-modal="true" aria-labelledby={titleId} aria-describedby={descriptionId} aria-busy={busy}
        onCancel={event => { event.preventDefault(); if (!busy) onClose(); }}>
        <form onSubmit={event => { event.preventDefault(); if (file && !busy) onImport(file); }}>
            <div className="esave-confirmation-heading">
                <span className="esave-confirmation-icon"><Upload size={23} aria-hidden="true" /></span>
                <h2 id={titleId}>Importar Excel</h2>
                <button type="button" disabled={busy} className="esave-button esave-confirmation-close" aria-label="Cerrar ventana" onClick={onClose}><X size={18} aria-hidden="true" /></button>
            </div>
            <div className="esave-confirmation-body">
                <p id={descriptionId} className="esave-muted">Descarga el Excel para usarlo como plantilla. La importación actualiza los IDs incluidos y añade los nuevos; conserva las demás filas.</p>
                <p className="esave-caption">Una hoja con ID Neuro, Descripción y Disponible CC (Sí/No o booleano). Hasta 5000 filas y 2 MB. Sin fórmulas. Si hay un error no se guarda ninguna fila.</p>
                <div className="esave-excel-file" role="group" aria-label="Archivo Excel">
                    <input ref={fileInput} aria-label="Archivo Excel" hidden disabled={busy} type="file" accept=".xlsx" onChange={event => setFile(event.target.files?.[0] || null)} />
                    <button ref={firstRef} type="button" className="esave-button" disabled={busy} onClick={() => fileInput.current?.click()}><FileSpreadsheet size={17} aria-hidden="true" />Seleccionar Excel</button>
                    <span className="esave-caption esave-excel-filename" aria-live="polite">{file?.name || 'Ningún archivo seleccionado'}</span>
                </div>
                {error && <div className="esave-notice" role="alert"><p>{error}</p></div>}
            </div>
            <div className="esave-confirmation-actions">
                <button type="button" className="esave-button" disabled={busy} onClick={onClose}>Cancelar</button>
                <button type="submit" className="esave-button esave-button-primary" disabled={busy || !file}><Upload size={17} aria-hidden="true" />{busy ? 'Importando…' : 'Importar Excel'}</button>
            </div>
        </form>
    </dialog>, document.body);
}
